import React, {FC} from 'react';
import {graphql} from 'gatsby';
import ModuleCertificateRouter from
  '../../../components/Certificate/ModuleCertificateRouter';
import {
  data as pageDataJSON,
} from '../../../data/publicCertificatePageData.json';

interface Props {
  data: any,
}

const ModuleCertificatePage:FC<Props> = ({data}) => {
  const pageData = {
    ...data,
    ...pageDataJSON,
  };
  return (
    <ModuleCertificateRouter pageData={pageData}/>
  );
};

export default ModuleCertificatePage;

export const pageQuery = graphql`
  query PublicModuleCertificatePage {
    englishCourses:allBrandEducationCourse(filter: {
      publish_details: {locale: {eq: "en"}}}) {
      edges {
        node {
          id
          locale
          coursename
          courseslug
          coursedescription
          tags
          active
          modules {
            id
            moduleslug
            certificatedisplayname
            lessons {
              id
              lessonname
            }
          }
        }
      }
    }
    nonEnglishCourses:allBrandEducationCourse(filter: {
      locale:{ne: "en"},
      publish_details: {locale: {ne: "en"}}}) {
      edges {
        node {
          id
          locale
          coursename
          tags
          courseslug
          active
          modules {
            id
            moduleslug
            certificatedisplayname
            lessons {
              id
              lessonname
            }
          }
        }
      }
    }
    site {
      siteMetadata {
        social {
          twitter
          facebook
          instagram
          linkedIn
        }
      }
    }
  }
`;

